import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
// 路由数组
import routes from './router';
// ipeso地铁广告判断注册页
import { openWhatsapp } from '@/utils/utils';
import { checkIpesoInviteCode, registerMonitor } from './utils';

export function RouterControl(route) {
  return (
    <Route
      path={ route.path }
      render={props => {
        // 墨西哥地铁注册页判断是否跳转到WhatsApp
        if (route.path.includes('register')) {
          if (checkIpesoInviteCode()) {
            registerMonitor();
            openWhatsapp('525623906578', 'Hola estoy interesado en el préstamo de iPeso! Ví el anuncio en metro.');
            return false
          }
        }
        return (<route.component {...props} routes={route.routes} />)
      }}
    />
  );
}

function App() {
  return (
    <Router>
      <Switch>
        {routes.map((route, i) => (
          <RouterControl
            key={ i }
            { ...route }
          />
        ))}
      </Switch>
    </Router>
  );
}

export default App;
